import { SignRequestStatus } from 'shared/domains/apollo/generated/types';
import { SupportedFileMimeTypes } from 'shared/domains/filesystem';
/**
 * Esigning
 */
export const PROVIDER_IDS = {
    /** @deprecated Will be removed and should not be used */
    SCRIVE: '3eedcbaf-af27-47e6-a938-7ac200a153d0',
    DOCUSIGN: 'bb2f4618-ba66-490d-a30f-d31863b94127',
    IDURA: 'e8321974-1fb4-4014-b09e-632c100098d6',
};
export const ACTIVE_SIGN_REQUEST_STATUSES = [
    SignRequestStatus.Signed,
    SignRequestStatus.Pending,
    SignRequestStatus.Opened,
    SignRequestStatus.Creating,
];
export const ESIGNING_PL_FILES_ATTACHMENT_SUPPORTED_MIME_TYPES = [
    SupportedFileMimeTypes.PDF,
    SupportedFileMimeTypes.DOCX,
];
export const ESIGNING_UPLOAD_ATTACHMENT_SUPPORTED_MIME_TYPES = [SupportedFileMimeTypes.PDF];
export const ESIGNING_SENDOUT_SUPPORTED_MIME_TYPES = [SupportedFileMimeTypes.PDF, SupportedFileMimeTypes.DOCX];
/**
 * Approval
 */
export var ApprovalErrorSubcodes;
(function (ApprovalErrorSubcodes) {
    ApprovalErrorSubcodes["LacksApproval"] = "ERROR_DOCUMENT_LACKS_APPROVAL";
    ApprovalErrorSubcodes["AlreadyPending"] = "ERROR_APPROVAL_REQUEST_ALREADY_PENDING";
    ApprovalErrorSubcodes["AlreadyApproved"] = "ERROR_APPROVAL_REQUEST_ALREADY_APPROVED";
    ApprovalErrorSubcodes["AlreadyRejected"] = "ERROR_APPROVAL_REQUEST_ALREADY_REJECTED";
    ApprovalErrorSubcodes["AlreadyCancelled"] = "ERROR_APPROVAL_REQUEST_ALREADY_CANCELLED";
})(ApprovalErrorSubcodes || (ApprovalErrorSubcodes = {}));
export const APPROVAL_IGNORE_CODES = [
    ApprovalErrorSubcodes.AlreadyPending,
    ApprovalErrorSubcodes.AlreadyApproved,
    ApprovalErrorSubcodes.AlreadyRejected,
    ApprovalErrorSubcodes.AlreadyCancelled,
];
